import { useMemo } from 'react';
import { Row, TextButton, Typography } from 'seagull';
import { ArrowHead } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useResponsive } from "../../../../contexts";
import { useFeatureFlags } from "../../../../../hooks/useFeatureFlags";
import { getStepName } from "../../../ClientOnboarding.utils";
import { getVendorGradientStyle } from "../../ClientOnboardingV2.utils";
import desktopStyles from "../../OnboardingPage/Steps/StepsContainer/StepsContainerDesktop.module.scss";
import mobileStyles from "../../OnboardingPage/Steps/StepsContainer/StepsContainerMobile.module.scss";
import { jsx as _jsx } from "react/jsx-runtime";
export const GetHeaderTID = parentTestId => getTestIds({
  parentTestId
});
export const Header = _ref => {
  let {
    currentStep,
    relationship,
    onBack,
    testId
  } = _ref;
  const {
    MULTIPLE_LEGAL_TERMS_DOCUMENTS
  } = useFeatureFlags();
  const {
    isMobile
  } = useResponsive();
  const {
    HeaderTestIds
  } = useMemo(() => GetHeaderTID(testId), [testId]);
  const gradientStyle = getVendorGradientStyle(relationship.vendor.branding);
  const stepTitle = useMemo(() => getStepName(currentStep, relationship, Boolean(MULTIPLE_LEGAL_TERMS_DOCUMENTS)), [currentStep, relationship, MULTIPLE_LEGAL_TERMS_DOCUMENTS]);
  const styles = isMobile ? mobileStyles : desktopStyles;
  if (isMobile) {
    return /*#__PURE__*/_jsx(Typography, {
      variant: "h3",
      weight: "normal",
      className: styles.title,
      "data-testid": HeaderTestIds.StepTitle(),
      children: stepTitle
    });
  }
  return /*#__PURE__*/_jsx(Row, {
    className: styles.header,
    style: gradientStyle,
    "data-testid": HeaderTestIds.Root(),
    children: /*#__PURE__*/_jsx(Row, {
      className: styles.headerContent,
      "data-testid": HeaderTestIds.HeaderContent(),
      children: /*#__PURE__*/_jsx(TextButton, {
        prefixIcon: /*#__PURE__*/_jsx(ArrowHead, {
          direction: "left"
        }),
        onClick: onBack,
        skin: "secondary",
        underline: "never",
        variant: "h4",
        weight: "normal",
        "data-testid": HeaderTestIds.BackButton(),
        children: /*#__PURE__*/_jsx("span", {
          "data-testid": HeaderTestIds.StepTitle(),
          children: stepTitle
        })
      })
    })
  });
};